<!-- file-upload-ui.component.html -->
<div class="relative" [class.compact-upload]="compact">
  <div
    *ngIf="showViewIconExclusiveLy"
    class="grid cursor-pointer place-items-center place-content-start top-[0] left-[-15px] z-10 absolute"
    (click)="viewFile()"
    title="View file"
  >
    <span class="material-symbols-rounded text-[16px] text-[#4d5d76]"
      >visibility</span
    >
  </div>

  <div
    *ngIf="
      (ccEdit && !showViewIconExclusiveLy) || (ccEdit && !shouldShowViewIcon)
    "
    class="grid cursor-pointer place-items-center place-content-start top-[0] left-[-15px] z-10 absolute"
    (click)="viewFile()"
    title="View file"
  >
    <span class="material-symbols-rounded text-[16px] text-[#4d5d76]"
      >visibility</span
    >
  </div>

  <div
    class="z-10 relative text-white flex flex-col gap-1"
    *ngIf="isFileUploaded"
  >
    <!-- View File Icon (normal mode) -->
    <div
      *ngIf="shouldShowViewIcon && !showViewIconExclusiveLy && !showMagnifyOnly"
      class="grid cursor-pointer place-items-center place-content-start top-[0] left-[-13px] z-10 absolute"
      [ngClass]="disabled ? 'hidden' : ''"
      (click)="viewFile()"
      title="View file"
    >
      <span class="material-symbols-rounded text-[16px] text-[#4d5d76]"
        >visibility</span
      >
    </div>

    <!-- Magnify icon (exclusive mode) — sits at delete position, top-right -->
    <div
      *ngIf="showMagnifyOnly"
      class="grid cursor-pointer place-items-center place-content-start top-[0] right-[-13px] absolute"
      (click)="viewFile(); $event.stopPropagation()"
      title="View file"
    >
      <span class="material-symbols-rounded text-[16px] text-[#4d5d76]"
        >expand_content</span
      >
    </div>

    <!-- Delete File Icon — hidden in exclusive/magnify mode -->
    <div
      *ngIf="!showMagnifyOnly"
      class="grid cursor-pointer place-items-center place-content-start top-[0] right-[-15px] absolute"
      [ngClass]="disabled ? 'hidden' : ''"
      (click)="onRemoveFile()"
      title="Delete file"
    >
      <span class="material-symbols-rounded text-[16px] text-red-500"
        >delete</span
      >
    </div>
  </div>

  <div
    class="upload-tile overflow-hidden w-[130px] h-[130px] p-4 border-2 bg-white rounded-lg flex flex-col items-center justify-center relative"
    [ngClass]="[
      highlightBorder ? 'border-secondary/70' : '',
      disabled ? 'cursor-not-allowed' : '',
      classNames,
    ]"
    (click)="onUploadClick()"
  >
    <div
      class="cursor-pointer w-[80%] mx-auto h-[70%]"
      [ngClass]="disabled ? 'cursor-not-allowed' : ''"
    >
      <ng-content></ng-content>
      <img *ngIf="compact && (!isFileUploaded || alwaysShowCompactPlaceholder)" class="compact-placeholder" [src]="defaultPhoto" alt="">

      <img
        class="w-full h-full object-contain rounded-lg"
        #imageElem
        [src]="safeCurrentPhoto"
        [ngClass]="{ 'd-none': !isFileUploaded || (compact && alwaysShowCompactPlaceholder) }"
        accept=".jpg, .jpeg, .png, .svg"
        (error)="defaultImagePlaceholder($event)"
      />
      <input
        type="file"
        hidden
        name="fileUploadInput"
        [accept]="acceptPdf ? 'image/*,application/pdf' : 'image/*'"
        class="form-control hidden"
        #fileInput
        (change)="setSelectedImg($event)"
      />
    </div>

    <div
      [ngClass]="editing ? '!text-error' : ''"
      class="upload-caption text-center text-sm mb-1"
    >
      <h3 class="font-bold mt-2 px-2">{{ formatLabel }}</h3>
      <small *ngIf="!isFileUploaded && hint">{{ hint }}</small>
      <small *ngIf="!isFileUploaded && !hint"
        >.png, .jpg, .svg, {{ acceptPdf ? ".pdf" : "" }} (Max. 2MB)</small
      >
    </div>
  </div>

  <!-- Image Preview Modal -->
  <div
    *ngIf="showImageModal"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center top-0 left-0 z-50"
    (click)="onModalBackdropClick($event)"
  >
    <div
      class="relative w-screen h-screen flex flex-col bg-white shadow-2xl overflow-hidden"
      (click)="$event.stopPropagation()"
    >
      <!-- Header -->
      <div
        class="flex items-center justify-between bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-4 border-b border-gray-200 flex-shrink-0"
      >
        <h3 class="font-semibold text-gray-800 text-lg">Document Preview</h3>
        <button
          class="flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-200 transition-colors duration-200"
          type="button" (click)="closeImageModal()"
          title="Close"
        >
          <span class="material-symbols-rounded text-red-500 text-xl"
            >close</span
          >
        </button>
      </div>

      <!-- Image Viewer -->
      <div
        *ngIf="!isPdfFile"
        class="flex-1 flex items-center justify-center p-6 bg-gray-50 min-h-0 overflow-hidden"
      >
        <div class="w-full h-full flex items-center justify-center">
          <img
            [src]="
              currentFileUrl.includes('base64')
                ? safeCurrentPhoto
                : getFullImageUrl(currentFileUrl)
            "
            [alt]="currentFileName"
            class="max-w-full max-h-full object-contain rounded-lg shadow-lg"
            style="image-rendering: crisp-edges"
          />
        </div>
      </div>

      <!-- PDF Viewer -->
      <div
        *ngIf="isPdfFile"
        class="flex-1 flex items-center justify-center p-6 bg-gray-50 min-h-0 overflow-auto"
      >
        <iframe
          [src]="
            currentFileUrl.includes('base64')
              ? currentFileUrl
              : getFullImageUrl(currentFileUrl)
          "
          class="w-full h-full rounded-lg shadow-lg border-0"
          title="PDF Preview"
        ></iframe>
      </div>

      <!-- Footer -->
      <div
        class="flex items-center justify-center bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-3 border-t border-gray-200 flex-shrink-0"
      >
        <div class="flex items-center gap-2 text-gray-600 text-sm">
          <span class="material-symbols-rounded text-base">description</span>
          <span class="font-medium truncate max-w-md">{{
            currentFileName
          }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
